import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getReportsFinanceByMaterialsCategories(options = {}) {
  return _apiRequestWrap(
    ModulesMap.REPORTS_FINANCE_BY_MATERIALS_CATEGORIES,
    ModulesConfigMap[ModulesMap.REPORTS_FINANCE_BY_MATERIALS_CATEGORIES].GET_REPORTS_FINANCE_BY_MATERIALS_CATEGORIES,
    options
  )
}

export default {
  [ModulesConfigMap[ModulesMap.REPORTS_FINANCE_BY_MATERIALS_CATEGORIES].GET_REPORTS_FINANCE_BY_MATERIALS_CATEGORIES]: _getReportsFinanceByMaterialsCategories,
}